import { z } from "zod";

export const addProductCompanySchema = z.object({
	companyId: z.number().min(1, "Company is required"),
	productId: z.number().min(1, "Product is required"),
	price: z.preprocess(
		(value) => {
			if (value === "" || value === null || value === undefined) {
				return undefined;
			}

			if (typeof value === "string") {
				return Number(value);
			}

			return value;
		},
		z
			.number({
				required_error: "Price is required",
				invalid_type_error: "Price must be a valid number",
			})
			.gt(0, "Price must be greater than 0")
	),
});

export type AddProductCompanyFormValues = z.infer<typeof addProductCompanySchema>;
